import { action } from 'typesafe-actions'
import { LoadingActions } from './types'

export const setLoading = () => action(LoadingActions.SET_LOADING, true)

export const clearLoading = () => action(LoadingActions.SET_LOADING, false)
